import {useEffect} from 'react';
import {errorScrollSections} from './errorScroll.constants';
import {scrollToFirstErrorSection} from './helper';

export function ScrollToError({
  errors,
  submitCount,
}: {
  errors: Record<string, any>;
  submitCount: number;
}) {
  useEffect(() => {
    if (submitCount === 0 || Object.keys(errors).length === 0) return;

    scrollToFirstErrorSection(errors, errorScrollSections);
  }, [errors, submitCount]);

  return null;
}
